import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination
} from "@material-ui/core";
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import FindInPageIcon from '@material-ui/icons/FindInPage';
import { getChangeLogs } from "../api/apiAudit";
import moment from 'moment'
import ParamsDetailsDialog from "./ParamsDetailsDialog";

class ChangeLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            selectedClient: null,
            changeLogs: [],
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            selectedParams: "",
            isOpen: false
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getChangeLogs(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getChangeLogs(this.state.activePage, this.state.selectedClient.id))
    };

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getChangeLogs(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getChangeLogs = (page, selectedClient) => {
        getChangeLogs({ params: { page: page, size: this.state.rowsPerPage, clientId: selectedClient } }, selectedClient).then((response) => {
            this.setState({
                changeLogs: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getParamDetails = (index) => {
        const { changeLogs } = this.state;
        let selectedParams = changeLogs[index].params;
        if (this.isJsonString(selectedParams.rawResponse)) {
            let rawResponse = JSON.parse(selectedParams.rawResponse);
            selectedParams.rawResponse = rawResponse;
        }
        this.setState({ selectedParams: selectedParams });
    }

    isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }


    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getChangeLogs(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    render() {

        let { changeLogs, specificsClients, isLoading, selectedClient } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let changeLogsList;
        let recordsNotFound;
        if (changeLogs && changeLogs.length > 0) {
            changeLogsList = changeLogs.map((changeLog, index) => {
                return <TableRow key={index}>
                    <TableCell>{changeLog.caller}</TableCell>
                    <TableCell>{moment.unix(changeLog.timestamp).format("DD-MM-YYYY HH:mm")}</TableCell>
                    <TableCell>{changeLog.action}</TableCell>
                    <TableCell>
                        <Fab color="secondary" size="small" onClick={() => this.setState({ isOpen: true }, () => this.getParamDetails(index))}>
                            <FindInPageIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("change_logs")} />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedClient !== null && <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="30%">{this.props.t("user")}</TableCell>
                                                        <TableCell component="th" scope="row" width="30%">{this.props.t("date")}</TableCell>
                                                        <TableCell component="th" scope="row" width="30%">{this.props.t("action")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("params")}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {changeLogsList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                                <TablePagination
                                    component="div"
                                    count={this.state.totalElements}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    page={this.state.activePage}
                                    onPageChange={this.handleChangePage}
                                    rowsPerPage={this.state.rowsPerPage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    backIconButtonText={this.props.t("previous_page")}
                                    labelRowsPerPage={this.props.t("rows_per_page")}
                                    nextIconButtonText={this.props.t("next_page")}
                                />
                            </Grid>
                        </Grid>}
                    </CardContent>
                </Card>
            </Grid>
            <ParamsDetailsDialog
                isOpen={this.state.isOpen}
                onClose={() => this.setState({ isOpen: false })}
                closeButtonTitle={this.props.t("close")}
                selectedParams={this.state.selectedParams}
            />
        </Grid>
    }
}

export default withSnackbar(withTranslation()(ChangeLogs))